// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  display: flex;
  height: 85vh;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f9f9f9;
}

.sidebar-panel {
  width: 25%;
  /* background-color: #004d7a; */
  color: #fff;
  padding: 20px;
  background-color: rgba(222, 236, 221, 0.9647);

  transition: all 0.3s ease;
  border-radius: 6px;
  height: 494px;
  color: #0d7c66;
}

.sidebar-title {
  font-size: 1.4rem;
  margin-bottom: 1rem;
  text-align: center;
  border-bottom: 2px solid #ffffff33;
  padding-bottom: 10px;
}

.report-list {
  list-style-type: none;
  padding: 0;
}

.report-item {
  padding: 12px 16px;
  margin-bottom: 8px;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.report-item:hover {
  background-color: rgb(223, 219, 219);
}

.report-item.selected {
  background-color: white;
  font-weight: bold;
}

.content-panel {
  width: 75%;
  padding: 5px 15px;
  background-color: #ffffff;
  height: 500px;
  overflow-y: auto;
}

.content-title {
  font-size: 1.6rem;
  margin-bottom: 20px;
  color: #333;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ccc;
  padding: 12px 15px;
  text-align: left;
}

.custom-table th {
  background-color: #eeeeee;
}

.placeholder-text {
  font-size: 1.2rem;
  color: #888;
  text-align: center;
  margin-top: 50px;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .dashboard-container {
    display: flex;
    height: 85vh;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    background-color: #f9f9f9;
  }
  .sidebar-panel {
    width: 25%;
    /* background-color: #004d7a; */
    color: #fff;
    padding: 20px;
    background-color: rgba(222, 236, 221, 0.9647);
    transition: all 0.3s ease;
    border-radius: 6px;
    height: 494px;
    color: #0d7c66;
  }
  .sidebar-title {
    font-size: 1.4rem;
    margin-bottom: 1rem;
    text-align: center;
    border-bottom: 2px solid #ffffff33;
    padding-bottom: 10px;
  }
  .report-list {
    list-style-type: none;
    padding: 0;
  }
}

@media screen and (width: 1440px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardSection/GenerateSalaryComponent/ReportsDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,aAAa;EACb,6CAA6C;;EAE7C,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,4DAA4D;IAC5D,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,+BAA+B;IAC/B,WAAW;IACX,aAAa;IACb,6CAA6C;IAC7C,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;AACA","sourcesContent":[".dashboard-container {\n  display: flex;\n  height: 85vh;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  background-color: #f9f9f9;\n}\n\n.sidebar-panel {\n  width: 25%;\n  /* background-color: #004d7a; */\n  color: #fff;\n  padding: 20px;\n  background-color: rgba(222, 236, 221, 0.9647);\n\n  transition: all 0.3s ease;\n  border-radius: 6px;\n  height: 494px;\n  color: #0d7c66;\n}\n\n.sidebar-title {\n  font-size: 1.4rem;\n  margin-bottom: 1rem;\n  text-align: center;\n  border-bottom: 2px solid #ffffff33;\n  padding-bottom: 10px;\n}\n\n.report-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.report-item {\n  padding: 12px 16px;\n  margin-bottom: 8px;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.report-item:hover {\n  background-color: rgb(223, 219, 219);\n}\n\n.report-item.selected {\n  background-color: white;\n  font-weight: bold;\n}\n\n.content-panel {\n  width: 75%;\n  padding: 5px 15px;\n  background-color: #ffffff;\n  height: 500px;\n  overflow-y: auto;\n}\n\n.content-title {\n  font-size: 1.6rem;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.custom-table th,\n.custom-table td {\n  border: 1px solid #ccc;\n  padding: 12px 15px;\n  text-align: left;\n}\n\n.custom-table th {\n  background-color: #eeeeee;\n}\n\n.placeholder-text {\n  font-size: 1.2rem;\n  color: #888;\n  text-align: center;\n  margin-top: 50px;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .dashboard-container {\n    display: flex;\n    height: 85vh;\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n    background-color: #f9f9f9;\n  }\n  .sidebar-panel {\n    width: 25%;\n    /* background-color: #004d7a; */\n    color: #fff;\n    padding: 20px;\n    background-color: rgba(222, 236, 221, 0.9647);\n    transition: all 0.3s ease;\n    border-radius: 6px;\n    height: 494px;\n    color: #0d7c66;\n  }\n  .sidebar-title {\n    font-size: 1.4rem;\n    margin-bottom: 1rem;\n    text-align: center;\n    border-bottom: 2px solid #ffffff33;\n    padding-bottom: 10px;\n  }\n  .report-list {\n    list-style-type: none;\n    padding: 0;\n  }\n}\n\n@media screen and (width: 1440px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
